import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { aggregatedSurveyResponsesForSurveyIdSelector } from './survey-response-selector';
import { surveyResponsesStateForSurveyIdSelector } from '../../reducers/survey-selectors';
import { loadSurveyResponses } from '../actions/survey/load-survey-responses';

import { UiProgressBar } from '../../ui/ui-progress-bar';

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  surveyResponses: aggregatedSurveyResponsesForSurveyIdSelector(state, ownProps.surveyId),
  // IF (05/14/20): Need to watch the state for updates to refresh for real time updates
  surveyResponsesState: surveyResponsesStateForSurveyIdSelector(state, ownProps.surveyId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadSurveyResponses: () => dispatch(loadSurveyResponses(ownProps.surveyId)),
  },
});

type InputProps = {
  surveyId: number;
  onClickFailed?: () => void;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const SurveyResponseProgressBar = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  const { surveyResponses, actions } = props;

  useEffect(() => {
    actions.loadSurveyResponses();
  });

  const totalComplete = surveyResponses.filter((response) => response.hasAnswer).length;
  const totalFailed = surveyResponses.filter((response) => response.hasError).length;
  const totalSent = surveyResponses.length;

  return (
    <UiProgressBar
      successfulCount={totalComplete}
      failedCount={totalFailed}
      totalCount={totalSent}
      actionText="completed"
    />
  );
});
